module.exports = {
  message: {
    login: "Login",
    Username: "Username",
    zh: "Chinese",
    en: "English",
    out_name: "WIN365",
    out_app_kind: "Entertainment",
    first: "Top Entertainment",
    k_score: "K Ratings",
    install: "Installation",
    install_free: "GET",
    android_no_support: "NO support for android",
    start_download: "start download",
    down_fail: "download failed",
    try_again: "try again",
    installing: "installing",
    install_introduce: "Installation guide",
    appal_video_guild: "Apple APP installation video tutorial",
    over: "Completed",
    open_in_itune:
      "Please follow the prompts to open the link in itunes to install",
    intro: "Introduction",
    out_intro:
      "WIN365 is one of the best gaming groups in the world. Headquartered in the Philippines, with a legal PAGCOR gaming license, it operates multiple sports entertainment media and casino brands, and its business scope covers the world. Our group has managers with more than 10 years of experience in the gaming industry and more than 2,000 professional service employees. They are vigorously promoting strategic cooperation in competitive sports book, strictly monitoring and screening all types of games to ensure their fairness. All games and products of the group have undergone multiple tests and audits to ensure accurate odds and settlements, and provide users with a fair and high-quality gaming experience.",
    score_and_post: "Ratings & Reviews",
    fullscore: "out of 5",
    new_fun: "New function",
    out_new_feature: "",
    info: "Information",
    out_distributor: "Win365",
    distributor: "Provider",
    size: "Size",
    kind: "Category",
    need_ios_compatible: "Requires iOS 9.0 or later, compatible with iPhone",
    compatible: "Compatibility",
    out_langs: "Chinese,English,Japanese,Vietnamese,Thai",
    lang: "Languages",
    age_limit: "Age Rating",
    age: "Age",
    out_copyright: "",
    copyright: "Copyright",
    out_app_price: "Free",
    price: "Price",
    policy_privay: "Privacy Policy",
    randomCode: "Unique identification",
    under18: "Over 18 years old",
    disclaimer: "Disclaimer",
    disclaimer_detail:
      "This website only provides developers with App download and installation hosting. The content and operation-related matters in the App are the responsibility of the App developer and have nothing to do with this website.",
    step1: "Step 1",
    click_coner: "Click on the upper right corner",
    button: "Button",
    step2: "Step 2",
    open_IE: 'Select "Open in Safari"',
    click_copy: 'Click the "Copy" link',
    outof_limit:
      "The number of downloads today has reached the limit, please try again tomorrow!",
    back_detail: "Please return to the desktop for details after installation",
    desc: "Configuration profile",
    desc_why_install:
      "1. What is a configuration profile and why does it need to be installed?",
    desc_reson:
      "The configuration profile is certified by Apple and used to record the user's device. Please use it with confidence. The installation of configuration profile is to register your device to the Apple user library. It is a prerequisite for installing Apple APP installation assistant.",
    desc_explain_title:
      "2. If I got stuck on the setting page during installation, how to solve it?",
    desc_explain_desc:
      "Getting stuck is a bug of iOS system. Solution: Return to home screen-slide up-close the setting page-reinstall.",
    desc_why_password:
      "3.Why do I need to enter the password when installing the configuration profile? What password? ",
    desc_psw_reson:
      'In order to confirm that the device owner is operating, you need to enter "Unlock Passcode" when installing the configuration profile',
    desc_know: "Acknowledged",
    guild_title_1: "How to enable developer mode in IOS16?",
    guild_title: "What is configuration profile?",
    guild: "Installation guide",
    guild_step1: "Step 1: Allow opening the configuration profile",
    guild_step2: 'Step 2: Click the "Install" button in the upper right corner',
    guild_step3: "Step 3: Enter unlock passcode",
    guild_step4: 'Step 4: Click the "Install" button below',
    error1: "the network is abnormal, please contact customer service\n",
    ageleft: "Over ",
    ageright: " years old",
    versionleft: "Requires iOS ",
    versionright: " or later, compatible with iPhone",
    to_main_site: "To Main Site",
    release_time: "Release date",
    previous_version: "Previous Version",
    version_info: "Version Information",
    ios16Tip1: "For ios16 and above, please enable the developer mode first",
    ios16Tip2: "“Settings->Privacy and Security->Developer Mode->Enable”"
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/en.js